import React, { Fragment, Component } from 'react';

import API from '../../../../utils/API';
import FieldModal from '../../../../components/modals/fieldModal';

import 'react-toggle/style.css';
import ViewsTable from '../../../../components/tables/ViewsTable';
import InputField from '../../../../components/inputs/inputField';

class InventoryAddAttendeesModal extends Component {
    constructor(props) {
        super(props);
        const columns = {
            firstName: 'First Name',
            lastName: 'Last Name',
            email: 'Email'
        };
        const columnTypes = {
            firstName: 'text',
            lastName: 'text',
            email: 'text'
        };
        const columnWidth = {
            firstName: 150,
            lastName: 150,
            email: 200
        };
        const toggledColumns = {};
        const normalizedColumns = Object.keys(columns).map((cfc) => {
            toggledColumns[cfc] = true;
            return {
                label: columns[cfc],
                key: cfc,
                value: cfc,
                type: columnTypes[cfc],
                sortAsc: false,
                sortDesc: false
            };
        });

        this.state = {
            orgId: props.orgId,
            eventId: props.eventId,
            checkedAttendees: {},
            searching: false,
            searchTerm: '',
            submitting: false,
            columns: columns,
            columnTypes: columnTypes,
            normalizedColumns: normalizedColumns,
            toggledColumns: toggledColumns,
            columnWidth: columnWidth,
            selectedColumnSort: null,
            sortDesc: false
        };
    }



    filterAttendees = (attendees) => {
        return attendees.filter((a) => !this.props.existingAttendees.find((at) => at._id == a._id));
    };

    addAttendees = async (attendees) => {
        this.setState({ submitting: true });
        const { eventId, orgId, editedItem } = this.props;
        await API()
            .patch(`Organizations/${orgId}/events/${eventId}/inventory/${editedItem._id}`, {
                name: editedItem.name,
                redeemedBy: attendees,
                request: 'addRedeemedBy'
            })
            .then((res) => {
                if (res.data) {
                    let allAttendees = this.props.attendees;
                    let attendeeObjects = allAttendees.filter((a) => attendees.includes(a._id)).map((a) => {
                        return {
                            _id: a._id,
                            firstName: a.firstName,
                            lastName: a.lastName,
                            email: a.email
                        };
                    });
                    this.props.addRedeemedByAttendees(attendeeObjects);
                    this.props.toggle();
                }
            }).catch((e) => {
                let message = e.response && e.response.data && e.response.data.message ? e.response.data.message : 'An error occurred while adding attendees.';
                alert(message);
            });
    };

    updatedCheckedAttendees = (checked) => {
        this.setState({ checkedAttendees: checked });
    };

    sortData = (column, sortAsc, sortDesc) => {
        const { normalizedColumns } = this.state;
        const updatedColumns = normalizedColumns.map((col) => {
            if (col.key == column.key) {
                col.sortAsc = sortAsc;
                col.sortDesc = sortDesc;
            } else {
                col.sortAsc = false;
                col.sortDesc = false;
            }
            return col;
        });

        this.setState({
            normalizedColumns: updatedColumns,
            selectedColumnSort: column,
            sortDesc: sortDesc ? true : false
        });
    };

    render() {
        const {
            submitting,
            checkedAttendees,
            columnWidth,
            normalizedColumns,
            toggledColumns,
            selectedColumnSort,
            sortDesc,
            searchTerm,
            columns
        } = this.state;
        const { attendees, isOpen, toggle } = this.props;
        let availableAttendees = this.filterAttendees(attendees);
        let data = availableAttendees;
        if (searchTerm.length > 0) {
            const searchTerms = searchTerm.toLowerCase().split(' ');
            searchTerms.forEach((term) => {
                if (term != '') {
                    data = data.filter((entry) => {
                        let found = false;
                        Object.keys(columns).forEach((key) => {
                            if (term != '' && entry[key] && entry[key].toString().toLowerCase().includes(term)) {
                                found = true;
                            }
                        });
                        return found;
                    });
                }
            });
        }
        if (selectedColumnSort) {
            data = availableAttendees.sort((a, b) => {
                const columnType = selectedColumnSort.type || typeof a[selectedColumnSort.key];
                if (a[selectedColumnSort.key] && b[selectedColumnSort.key]) {
                    switch (columnType) {
                        case 'string':
                            return a[selectedColumnSort.key]
                                .toLowerCase()
                                .trim()
                                .localeCompare(b[selectedColumnSort.key].toLowerCase().trim());
                        case 'number':
                            return a[selectedColumnSort.key] - b[selectedColumnSort.key];
                        case 'date':
                            return (
                                new Date(a[selectedColumnSort.key]).getTime() -
                                new Date(b[selectedColumnSort.key]).getTime()
                            );
                        case 'time':
                            return (
                                new Date(a[selectedColumnSort.key]).getTime() -
                                new Date(b[selectedColumnSort.key]).getTime()
                            );
                        case 'boolean':
                            const a1 = a[selectedColumnSort.key] ? 'yes' : 'no';
                            const b1 = b[selectedColumnSort.key] ? 'yes' : 'no';
                            return a1.localeCompare(b1);
                        default:
                            return a[selectedColumnSort.key]
                                .toLowerCase()
                                .trim()
                                .localeCompare(b[selectedColumnSort.key].toLowerCase().trim());
                    }
                } else if (a[selectedColumnSort.key]) {
                    return 1;
                }
                return -1;
            });

            availableAttendees = sortDesc ? availableAttendees.reverse() : availableAttendees;
        }
        return (


            <div>
                <FieldModal
                    size="large"
                    isOpen={isOpen}
                    modalTitle={"Add Attendees to Inventory Item"}
                    bodyHeaderText={''}
                    bodyDescription={''}
                    bodyContent={() => {
                        return (
                            <div>
                                <InputField
                                    classes="viewSearch"
                                    placeholder="Search "
                                    clickIcon={true}
                                    required={true}
                                    value={searchTerm}
                                    onChange={(e) => {
                                        clearTimeout(this.searchTimeout);
                                        this.setState({ searchTerm: e.target.value });
                                    }}
                                    prefix={<i className="las la-search" style={{ marginRight: 5, transform: 'rotate(270deg)' }} />}
                                    inputIcon={searchTerm !== '' &&
                                        <i
                                            onMouseDown={() => this.setState({ searchTerm: '', searching: false })}
                                            //onClick={() => this.setState({ searchTerm: '', searching: false })}
                                            className="las la-times-circle"
                                            style={{ visibility: searchTerm == '' ? 'hidden' : 'visible' }}
                                        />}
                                />
                                <ViewsTable
                                    title="Attendees"
                                    style={{ margin: 0, height: 'calc(100vh - 350px)' }}
                                    classes={"fit"}
                                    columns={normalizedColumns}
                                    toggledColumns={toggledColumns}
                                    data={data}
                                    mainColumnActive={false}
                                    columnWidth={columnWidth}
                                    checked={this.state.checkedAttendees}
                                    checkRow={(entryId) => {
                                        const checked = this.state.checkedAttendees;
                                        checked[entryId] ? delete checked[entryId] : (checked[entryId] = true);
                                        this.updatedCheckedAttendees(checked);
                                    }}
                                    checkAllRows={(entryIds) => {
                                        let checked = this.state.checkedAttendees;
                                        entryIds.length > 0
                                            ? entryIds.forEach((entryId) => {
                                                checked[entryId] = true;
                                            })
                                            : (checked = {});
                                        this.updatedCheckedAttendees(checked);
                                    }}
                                    sortData={this.sortData}
                                />{' '}
                                <p style={{ width: 200,  paddingTop: 10  }} className="small gray mb-0 mr-25">
                                    {Object.keys(checkedAttendees || {}).length} selected out of {data.length || 0} record
                                    {data?.length === 1 ? "" : "s"}
                                </p>
                            </div>)
                    }}
                    toggle={toggle}
                    actionButtonLabel={!submitting ? 'Submit' : 'Adding...'}
                    actionButton={() => {

                        this.setState({ submitting: true });
                        if (Object.keys(checkedAttendees).length > 0) {
                            this.addAttendees(Object.keys(checkedAttendees));
                        } else {
                            this.setState({ invalid: true, submitting: false });
                        }
                    }}
                    actionButtonDisabled={submitting}
                    isFullWidthBody={true}
                ></FieldModal>
            </div>

        );
    }
}

export default InventoryAddAttendeesModal;
